import React, { useRef, useEffect } from "react";
import {
  VideoSectionContainer,
  VideoWrapper,
  VideoElement,
} from "./VideoBackground.styled";

// Import your MP4 file
import pianoVideo from "../../Assets/video/animacija.mp4";

const VideoSection = () => {
  const videoRef = useRef(null);

  // Ensure video plays automatically
  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      // Try to play the video automatically
      video.play().catch((error) => {
        console.log("Video auto-play prevented:", error);

        // Fallback: Play on first user interaction
        const handleFirstInteraction = () => {
          video.play().catch((e) => console.log("Manual play failed:", e));
          document.removeEventListener("click", handleFirstInteraction);
        };

        document.addEventListener("click", handleFirstInteraction);
      });
    }
  }, []);

  return (
    <VideoSectionContainer id="video-section">
      <VideoWrapper>
        <VideoElement ref={videoRef} autoPlay loop muted playsInline>
          <source src={pianoVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </VideoElement>
      </VideoWrapper>
    </VideoSectionContainer>
  );
};

export default VideoSection;
